<template>
  <section class="container">
    <!-- 首页应用 -->
    <section class="top_box">
      <span class="top_box_left">首页应用</span>
      <ul>
        <li v-for="item in indexIconList" :key="item.url">
          <img
            :src="require(`../../assets/images/tabicon/tabicon_${iconStyle}/${item.url}`)"
            alt
          />
        </li>
        <li v-if="indexIconList.length >= 7">
          <img src="../../assets/images/icon_more_small.png" alt />
        </li>
      </ul>
      <section v-if="$store.state.common.theme==3" class="edit_4"  @click="toEdit">
        <span>编辑</span>
      </section>
      <section v-else class="edit"  @click="toEdit">
        <span>编辑</span>
      </section>
    </section>
    <!-- 全部应用 -->

    <template  v-if="$store.state.common.theme==3">
      <section
        :class="['all_mess',index==0?'marginTop':'']"
        v-for="(item,index) in home.indexCenter"
        :key="item.name"
      >
        <h3>{{item.name}}</h3>
        <ul  class="ul_4">
          <li
            @click="toPage(cur)"
            class="icon"
            v-for="cur in item.tbWapServerButtonList"
            :key="cur.serverName"
          >
            <img
              class="icon_img_content"
              :src="require(`../../assets/images/tabicon/tabicon_${iconStyle}/${cur.serverIcon}`)"
            />
            <p class="icon_desc">{{cur.serverName}}</p>
          </li>
        </ul>
      </section>
    </template>
    <template  v-else>
      <section
        :class="['all_mess',index==0?'marginTop':'']"
        v-for="(item,index) in home.indexCenter"
        :key="item.name"
      >
        <h3>{{item.name}}</h3>
        <ul  class="ul">
          <li
            @click="toPage(cur)"
            class="icon"
            v-for="cur in item.tbWapServerButtonList"
            :key="cur.serverName"
          >
            <img
              class="icon_img_content"
              :src="require(`../../assets/images/tabicon/tabicon_${home.iconStyle}/${cur.serverIcon}`)"
            />
            <p class="icon_desc">{{cur.serverName}}</p>
          </li>
        </ul>
      </section>
    </template>
  </section>
</template>
<script>
import util from "../../utils/util";
import { getPermissionByUserId, getIntServTemplateByMarketId, getTenantBuildList,getPerssionCompanyList, getOfficeMaterialListByMarketId, getIndexStyleByMarketId, loadParkHeaderById, getVisitorRegByParams,getYoGoPathByMarketId,updateOpenYoGo } from '../../utils/api'
import { mapState, mapActions } from "vuex";

export default {
  name: "allModule",
  data() {
    return {
      // iconStyle:this.home.iconStyle
    };
  },
  computed: {
    ...mapState({
      common: state => state.common,
      home: state => state.home
    }),
    indexIconList() {
      let newA = this.home.indexNavList.filter(item => item.text != "全部");
      if (newA.length >= 8) {
        newA = newA.filter((item, index) => {
          return index < 7;
        });
      }
      return newA;
    },
    iconStyle(){
       if(this.home){
        return this.home.iconStyle
       }
       return 0
    }
  },
  created() {
    if (this.home.indexNavList.length == 0) {
      this.getIndexStyleByMarketId()
    }
  },
  methods: {
    ...mapActions([
      "getIndexStyle",
    ]),
    toEdit() {
      this.$router.push('/editAllModule')
    },
    // 首页配置tab
    getIndexStyleByMarketId() {
      getIndexStyleByMarketId({
        marketId: this.$route.query.marketId || this.common.marketInfo.id
      }).then(res => {
        console.log(res);
        if (res.res.code === 10000 && res.body) {
          this.getIndexStyle(res.body);
        }
      });
    },
    toPage(val) {
      console.log("in toPage   "  + JSON.stringify(val))
      if (val.text === '全部') {
        this.$router.push("/allModule")
        return;
      }
      if (val.serverPath) {
        if (
          !this.$store.state.common.userId &&
          val.serverPath.indexOf('emptyShopList') == -1 &&
          val.serverPath.indexOf('BusinessLife') == -1 &&
          val.serverPath.indexOf('policyServices') == -1 &&
          val.serverPath.indexOf('officeService') == -1 &&
          val.serverPath.indexOf('accessControl') == -1 &&
          val.serverPath.indexOf('hpRecharge') == -1 &&
          val.serverPath.indexOf('meetingRoom') == -1 &&
          val.serverPath.indexOf('parkingService') == -1
        ) {
          this.$router.push({
            path: '/login'
          });
        } else {
          console.log('isOtherPath ===  ' + val.isOtherPath)
          console.log('serverPath =====' +  val.serverPath)
          if (val.serverPath.indexOf("http:") > -1 || val.serverPath.indexOf("https:") > -1) {

            // if(val.serverPath.indexOf("wxaurl") > -1){ //打开小程序
            if(val.isOtherPath)  {
              window.location.href =  val.serverPath
            }else{
              localStorage.setItem("src", val)
            // 跳转地址
              this.$router.push(`/iframePage`)

            }
           
          } else if(val.serverPath.indexOf("weixin:") > -1 ){   //weixin://dl/business/?t=hLfqQ4idb1o 
             window.location.href =  val.serverPath
            //  'weixin://dl/business/?t=hLfqQ4idb1o'
            //  val.serverPath
          }if(val.isOtherPath)  {
            window.location.href =  val.serverPath
          }else {
            if (val.serverPath == '/comReporting') { // 企业报表
              getPermissionByUserId({ marketId: this.common.marketInfo.id, userId: this.common.userId }).then(res => {
                console.log(res)
                if (res.res.code === 10000 && res.body) {
                  if (res.body.permission && res.body.permission.indexOf("REPORT") > -1) {
                    this.$router.push(val.serverPath);
                  } else {
                    util.showModal('您还没有权限', '请联系企业管理员获取更多权限', false, '知道了')
                  }
                }
              })
            } else if (val.serverPath == '/bill') { //在线账单
              getPermissionByUserId({ marketId: this.common.marketInfo.id, userId: this.common.userId }).then(res => {
                console.log(res)
                if (res.res.code === 10000 && res.body) {
                  if (res.body.permission && res.body.permission.indexOf("BILL") > -1) {
                    this.$router.push(val.serverPath);
                  } else {
                    util.showModal('您还没有权限', '请联系企业管理员获取更多权限', false, '知道了')
                  }
                }
              })
            } else if (val.serverPath == '/revenueIndex') { //营收填报
              getPermissionByUserId({ marketId: this.common.marketInfo.id, userId: this.common.userId }).then(res => {
                console.log(res)
                if (res.res.code === 10000 && res.body) {
                  if (res.body.permission && res.body.permission.indexOf("REVENUE") > -1) {
                    this.$router.push(val.serverPath);
                  } else {
                    util.showModal('您还没有权限', '请联系企业管理员获取更多权限', false, '知道了')
                  }
                }
              })
            } else if (val.serverPath == '/houseKeeping') { //家政服务
              getIntServTemplateByMarketId({}).then(res => {
                console.log(res);
                if (res.res.code === 10000 && res.body && res.body.intServTemplate) {
                  if (res.body.intServTemplate.length > 1) {
                    var serverPath1 = '/houseHomePage'
                    this.$router.push(serverPath1);
                  } else {
                    this.$router.push(val.serverPath);
                  }

                } else {
                  util.showModal('', '项目暂未开启服务', false, '我知道了', () => {

                  })
                }
              });
            } else if (val.serverPath == '/accessControl') {
              getTenantBuildList({
                'userId': this.common.userId,
                'marketId': this.common.marketInfo.id
              }).then(res => {
                if (res.res.code === 10000) {
                  this.$router.push(val.serverPath);
                } else {
                  var msg = "您还没有可以使用的门禁";
                  if (res.res.msg) {
                    msg = res.res.msg;
                  }
                  if(res.res.code != 10004){
                    util.showModal('', msg, false, '我知道了', () => {

                    })
                  }
                }
              });
            } else if (val.serverPath == '/hpRecharge') { //水电充值
              var params={
                 perssionVal: "RECHARGE",
                 marketId: this.common.marketInfo.id,
                 companyId:this.common.userTenantInfo.companyId,
                 userId:this.common.userId
              }
              getPerssionCompanyList(params).then(res => {
                  if (res.res.code === 10000) {
                    console.log("RECHARGE")
                    var list = res.body.companyList
                    var item =''
                    for(var i=0;i<list.length;i++){
                      if(list[i].isDeafult){
                        item = list[i]
                        break;
                      }
                    }
                    if(item){
                      var url = '/hpRecharge' + '?companyId=' + item.companyId
                      this.$router.push(url);

                    }else{
                      this.$router.push(val.serverPath);
                    }
                     
                  }else{
                    if(res.res.code != 10004){
                      util.showToast(res.res.msg)
                    }
                    // this.$router.push(val.serverPath);
                  }
              })

             } else if (val.serverPath == '/parkingCoupon') { //停车券
                  var params={
                    perssionVal: "PARKINGCOUPON",
                    marketId: this.common.marketInfo.id,
                    companyId:this.common.userTenantInfo.companyId,
                    userId:this.common.userId
                  }
                  getPerssionCompanyList(params).then(res => {
                      if (res.res.code === 10000) {
                        console.log("PARKINGCOUPON")
                        this.$router.push(val.serverPath);
                      }else{
                        if(res.res.code != 10004){
                          // util.showToast(res.res.msg)
                          util.showModal('您还没有权限', '请联系企业管理员获取更多权限', false, '知道了')
                        }
                      }
                  })

                // getPermissionByUserId({ marketId: this.common.marketInfo.id, userId: this.common.userId }).then(res => {
                //   console.log(res)
                //   if (res.res.code === 10000 && res.body) {
                //     if (res.body.permission && res.body.permission.indexOf("PARKINGCOUPON") > -1) {
                //       this.$router.push(val.serverPath);
                //     } else {
                //       util.showModal('您还没有权限', '请联系企业管理员获取更多权限', false, '知道了')
                //     }
                //   }
                // })
                  
            } else if (val.serverPath == '/officeService') {//办公耗材
              getOfficeMaterialListByMarketId({}).then(res => {
                if (res.res.code === 10000 && res.body && res.body.tbOfficeMaterials && res.body.tbOfficeMaterials.length > 0) {
                  this.$router.push(val.serverPath+'?pageTitle=' +val.serverName);
                } else {
                  util.showModal('', '项目暂未开启服务', false, '我知道了')
                }
              })
            } else if (val.serverPath == '/parking') {//月租车
              util.showLoading()
              loadParkHeaderById({ subProjectId: this.common.marketInfo.id, url: "/parking/rstParkHeader/queryParkHeaderList" }).then(res => {
                util.hideLoading()
                if (res.res && res.res.code === 10000 && res.body && res.body.data && res.body.data.length > 0) {
                  this.$router.push(val.serverPath);
                } else {
                  util.showModal('', '项目暂未开启服务', false, '我知道了')
                }
              })
            } else if (val.serverPath == '/fanke') {//访客
              getVisitorRegByParams({
                userId: this.common.userId,
                marketId: this.common.marketInfo.id
              }).then(res => {
                if (res.res && res.res.code === 10003 && res.body) {
                  util.showModal(res.body.title, res.body.desc, false, '知道了')
                } else {
                  this.$router.push(val.serverPath);
                }
              })
            } else if(val.serverPath == '/robot') { //机器人
              if(!this.common.userTenantInfo.id){
                util.showToast('未认证无法使用机器人')
              } else if(!this.common.userTenantInfo.openYogo) {
                util.showModal('授权提醒','即将离开租客服务，打开送餐机器人页面', true, '确定', () => {
                  this.getYoGoPathByMarketId()
                  updateOpenYoGo({
                    tenantId: this.common.userTenantInfo.id,
                    openYogo: 1
                  })
                })
              } else{
                this.getYoGoPathByMarketId()
              }
            } else {
              this.$router.push(val.serverPath +'?pageTitle=' +val.serverName);
            }
          }
        }
      } else {
        util.showToast('敬请期待')
      }
    },
    getYoGoPathByMarketId() {
      getYoGoPathByMarketId({
            tenantId: this.common.userTenantInfo.id
          }).then(res => {
            if(res.res.code == 10000){
              window.location = res.body.url
            } else {
              util.showToast('获取机器人地址失败')
            }
          })
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  min-height: 100vh;
}
.top_box {
  .flex();
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  align-items: center;
  height: 88px;
  border-bottom: 14px solid #eee;
  background: #fff;
  .top_box_left {
    flex-shrink: 0;
    display: block;
    padding: 0 20px 0 28px;
    font-size: 32px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  ul {
    .flex();
    flex: 1;
    // flex-wrap: nowrap;
    overflow: hidden;
    height: 88px;
    li {
      height: 88px;
      .flex();
      align-items: center;
      justify-content: center;
      width: 12.5%;
    }
    img {
      display: block;
      width: 90%;
      height: auto;
    }
  }
  .edit {
    flex-shrink: 0;
    padding: 0 28px 0 0;
    span {
      width: 80px;
      height: 44px;
      border-radius: 4px;
      border: 2px solid rgba(23, 64, 218, 1);
      font-size: 24px;
      color: rgba(23, 64, 218, 1);
      line-height: 44px;
      text-align: center;
      display: block;
    }
  }
  .edit_4{
    flex-shrink: 0;
    padding: 0 28px 0 0;
    span {
      width: 80px;
      height: 44px;
      border-radius: 4px;
      background: #a1805d;
      font-size: 24px;
      color: #ffffff;
      line-height: 44px;
      text-align: center;
      display: block;
    }

  }
}
.marginTop {
  margin-top: 102px;
}
// 全部应用
.all_mess {
  h3 {
    height: 44px;
    font-size: 32px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 44px;
    padding: 28px 0 20px 28px;
  }
  .ul {
    .flex();
    li {
      width: 25%;
      .flex();
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        display: block;
        width: 100px;
        height: 100px;
        padding: 24px 0 6px;
      }
      .icon_desc {
        height: 34px;
        font-size: 24px;
        color: rgba(51, 51, 51, 1);
        line-height: 34px;
        margin-bottom: 24px;
      }
    }
  }

  .ul_4 {
    .flex();
    padding-left: 20px;
  
    li {
      width: 160px;
      height: 160px;
      border-radius: 8px;
      border: 2px solid #e5e5e5;
      display: flex;
      flex-direction: column;
      margin-right: 15px;
      margin-bottom: 15px;

      img {
        display: block;
        margin-left: 40px;
        margin-top: 24px;
        width: 80px;
        height: 80px;
        
      }
      .icon_desc {
        height: 34px;
        width: 100%;
        text-align: center;
        font-size: 24px;
        margin-top: 12px;;
        color: rgba(51, 51, 51, 1);
        line-height: 34px;
      }
    }
  }
}
</style>
